import React from 'react';
import { AppFooter, EventLogo, Login, Signup, ThemeToggle } from 'components';
import { useParams } from 'react-router-dom';
import { useEventContext } from 'contexts';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

export const EventLogin = () => {
    const eventContext = useEventContext();
    const path = window.location.pathname;

    const params = useParams();
    const eventAlias = params.eventAlias;

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ position: 'fixed', top: 8, right: 8 }}>
                <ThemeToggle />
            </Box>
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', p: 2 }}>
                <Paper className="aq-content" sx={{ boxShadow: 'none' }}>
                    <div className="login-header">
                        <h1>{eventContext!.name}</h1>
                    </div>
                    <EventLogo />
                    {path.indexOf('login') > -1 && <Login eventAlias={eventAlias} />}
                    {path.indexOf('signup') > -1 && <Signup eventAlias={eventAlias} isEventSignup={true} />}
                    {!!eventContext?.event_site_url && (
                        <a className="aq-link" href={eventContext.event_site_url!} target="_blank" rel="noopener noreferrer">
                            {eventContext.name}
                        </a>
                    )}
                    {!eventContext?.event_site_url && <p> {eventContext?.name} </p>}
                </Paper>
            </Box>
            <AppFooter absoluteBottom={false} />
        </Box>
    );
};
